module.exports = __webpack_public_path__ + "media/images/show-more-61eede4f92d7a0ec2ed0c48f6c44f3a0.svg";